import { Reveal } from '@/components/ui/reveal';

const TRUST_ITEMS = [
  { value: 'Broad Coverage', detail: 'Hyderabad, Bangalore, and more cities in Telangana and AP' },
  { value: 'Every visit', detail: 'Photo & video evidence from the ground' },
  { value: 'Anywhere', detail: 'For owners in another city or another country' },
  { value: '7 days', detail: 'From sign-up to your first full report' },
];

/**
 * T4 Numbered stat strip · 4-up · qualifier under · hairline cells.
 * Set on paper rather than a dark band — the page keeps a single dark
 * moment, and it belongs to the closing letter.
 */
export function TrustStrip() {
  return (
    <section className="border-y border-line-strong">
      {/*
       * 2-up on phones, 4-up from lg. Stacking four items in a single column
       * cost ~280px of scroll for what is meant to be a glanceable strip.
       * Mobile separates rows with a hairline; lg separates columns instead.
       */}
      <div className="mx-auto grid max-w-6xl grid-cols-2 gap-x-6 px-4 sm:px-6 lg:grid-cols-4 lg:gap-x-0">
        {TRUST_ITEMS.map(({ value, detail }, idx) => (
          <Reveal
            key={value}
            delay={idx * 0.06}
            className="border-border py-6 [&:nth-child(-n+2)]:border-b sm:py-7 lg:border-l lg:px-7 lg:first:border-l-0 lg:first:pl-0 lg:last:pr-0 lg:[&:nth-child(-n+2)]:border-b-0"
          >
            <p className="font-display text-xl font-medium text-foreground sm:text-2xl">{value}</p>
            <p className="mt-2 text-sm leading-snug text-foreground/65">{detail}</p>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
